import type { ChatHistoryEntry } from '~/components/AiChat/controller/types';
import { compareDatesForSort, getRelativeTimeText, serverDateTimeToLocal } from '~/DateTimeUtils';

export interface GroupedHistory {
  groupLabel: string;
  items: ChatHistoryEntry[];
}

export const groupHistoryByRelativeTime = (history: ChatHistoryEntry[]): GroupedHistory[] => {
  const sortedHistory = [...history].sort((a, b) => compareDatesForSort(b.createdAt, a.createdAt));

  const groupsMap = new Map<string, ChatHistoryEntry[]>();

  sortedHistory.forEach((item) => {
    const localCreatedAt = serverDateTimeToLocal(item.createdAt);
    const groupLabel = getRelativeTimeText(localCreatedAt);

    if (!groupsMap.has(groupLabel)) {
      groupsMap.set(groupLabel, []);
    }

    groupsMap.get(groupLabel)?.push(item);
  });

  return Array.from(groupsMap.entries()).map(([groupLabel, items]) => ({
    groupLabel,
    items,
  }));
};
